class RenderEngine {

    constructor() {
        this.$window = $(window);

        this.viewport = {
            width: 0,
            height: 0,
            top: 0
        };

        this.count = 0;

        this.animation = {};
        this.size = {};
        this.visible = [];

        this.animationFrame;
        this.interval;

        this.isRunning = false;
        this.isPaused = false;

        this.measureViewport();

        this.addEventListeners();
    }

    add(animation) {
        let i = ++this.count;
        this.animation[i] = animation;
        this.measure(i);
        return i;
    }

    remove(i) {
        delete this.animation[i];
        delete this.size[i];
    }

    measure(i) {
        if (!i) for (let a in this.animation) {
            this.measure(a); return;
        }
        if(this.animation[i]){
	        let el = this.animation[i].$el;
	        this.size[i] = {
	            width: el.outerWidth(),
	            height: el.outerHeight(),
	            offset: el.offset()
	        };
	    }
    }

    measureViewport() {
        this.viewport = {
            width: this.$window.width(),
            height: this.$window.height()
        };
    }

    scrollTop() {
        this.viewport.top = this.$window.scrollTop();
    }

    markVisible() {
        this.visible = [];
        for (let a in this.animation) {
            if (this.viewport.top + this.viewport.height > this.size[a].offset.top && this.viewport.top < this.size[a].offset.top + this.size[a].height) {
                this.visible.push(a);
            }
        }
        this.visible.length ? this.start() : this.stop();
    }

    update() {
        for (let i of this.visible) {
            let animation = this.animation[i];
            if (animation.update) animation.update();
        }
    }

    heartbeat() {
        this.interval = setInterval(() => {
            if(!this.isPaused){
            	this.update();
            }
        }, 1000 / 60);
    }

    loop() {
        this.animationFrame = requestAnimationFrame((time) => {
    		this.loop();
        });
        if(!this.isPaused){
        	this.frame();
        }
    }

    frame() {
        for (let i of this.visible) {
            let animation = this.animation[i];
            if (animation.changed) {
                if (animation.clear) animation.clear();
                animation.render();
                animation.changed = false;
            }
        }
    }

    start() {
        if (this.isRunning) return;
        this.isRunning = true;
        this.heartbeat();
        this.loop();
    }

    stop() {
        if (!this.isRunning) return;
        this.isRunning = false;
        cancelAnimationFrame(this.animationFrame);
        clearInterval(this.interval);
    }

    unpause() {
        if (!this.isPaused) return;
        this.isPaused = false;
    }

    pause() {
        if (this.isPaused) return;
        this.isPaused = true;
    }

    reset() {
        this.size = {};
        this.visible = [];
        for (let a in this.animation) {
            if (this.animation[a].destroy) this.animation[a].destroy();
        }
        this.animation = {};
    }

    windowOnLoad() {
        this.measure();
        this.scrollTop();
        this.markVisible();
    }

    windowOnScroll() {
        this.scrollTop();
        this.markVisible();
    }

    windowOnResize() {
        this.measure();
        this.measureViewport();
        this.scrollTop();
        this.markVisible();
    }

    addEventListeners() {
        this.windowOnLoad = this.windowOnLoad.bind(this);
        this.windowOnScroll = this.windowOnScroll.bind(this);
        this.windowOnResize = this.windowOnResize.bind(this);

        this.$window.on('load', this.windowOnLoad);
        this.$window.on('scroll', this.windowOnScroll);
        this.$window.on('resize', this.windowOnResize);
    }

}

module.exports = RenderEngine;
